import { createSlice } from '@reduxjs/toolkit';

export const quotesSlice = createSlice({
  name: 'quotes',
  initialState: {
    quotesList: [],
    quote: {},
    quoteType2: {},
  },
  reducers: {
    setQuotesList: (state, action) => {
      state.quotesList = action.payload;
    },
    setQuote: (state, action) => {
      state.quote = action.payload;
    },
    setQuotesType2: (state, action) => {
      state.quoteType2 = action.payload;
    }
  }
});


// Action creators are generated for each case reducer function
export const { setQuotesList, setQuote, setQuotesType2 } = quotesSlice.actions;